import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { RouteLocationRaw } from 'vue-router'
import { PropType, computed } from 'vue'
import { checkMenuShow } from '@/store/tool'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'PermissionLink',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  to: {
    type: Object as PropType<RouteLocationRaw>,
  },
  role: {
    type: Object as PropType<string | string[] | null>,
  },
  isLink: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const hasPermission = computed(() => {
  if (!props.role) return true
  if (!props.isLink) return false
  const role = props.role
  if (Array.isArray(role)) {
    return role.some((r) => checkMenuShow(r))
  }
  return checkMenuShow(role)
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(hasPermission) && __props.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.to
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to"]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})